module.exports = __webpack_public_path__ + "img/banner.4538189b.png";